// extracted by mini-css-extract-plugin
export default {"title":"_9iybV","rowTitle":"Sb-y8","icons":"dBEGj","icon":"sx3p5","row":"MzPW5"};